<template>
  <div :class="outputObject.success ? 'AWS' : 'AWS__error'">
    <div class="AWS__header">
      <span>File</span>
      <v-btn icon @click="extend = !extend"
        ><v-icon>
          {{ extend ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        </v-icon></v-btn
      >
    </div>
    <div v-if="extend && outputObject.success">
      <div v-if="isValidJson" class="AWS__body">
        <div>
          <p>
            {{ outputObject.File.name }} ({{ outputObject.File.mime_type }})
          </p>
        </div>
        <div>
          <a @click="downloadFile">Download File</a>
        </div>
        <json-viewer
          :expand-depth="0"
          :value="outputObject"
          style="white-space: pre-line; border-radius: 15px; width: 100%"
        ></json-viewer>
      </div>
      <div
        v-if="!isValidJson && typeof outputObject !== 'string'"
        style="padding: 10px"
      >
        <v-progress-circular
          :size="20"
          :width="1"
          color="primary"
          indeterminate
        />
      </div>
      <div
        v-if="!isValidJson && typeof outputObject === 'string'"
        class="AWS__body"
      >
        {{ outputObject }}
      </div>
    </div>
    <div v-if="extend && !outputObject.success">
      <div class="Twilio__error_body">
        <span style="font-weight: bold">Error: </span> {{ outputObject }}
      </div>
    </div>
  </div>
</template>

<script>
import { helpers } from '@/mixins/helpers';
import 'vue-json-viewer/style.css';
import VueLoaders from 'vue-loaders';

import { saveAs } from 'file-saver';

import Vue from 'vue';
import JsonViewer from 'vue-json-viewer';

Vue.use(VueLoaders);

export default {
  name: 's3-download-output',
  components: { JsonViewer },
  props: {
    output: {},
    name: {},
    success: {},
  },
  mixins: [helpers],
  data() {
    return {
      extend: false,
    };
  },
  computed: {
    outputObject() {
      if (!this.isValidJson) {
        return this.output;
      }
      return typeof this.output !== 'string'
        ? this.output
        : JSON.parse(this.output);
    },
    isValidJson() {
      try {
        if (typeof this.output !== 'string') {
          return true;
        }
        JSON.parse(this.output);
        return true;
      } catch (e) {
        return false;
      }
    },
  },
  methods: {
    downloadFile() {
      const blob = this.dataURItoBlob(
        this.outputObject.File.file,
        this.outputObject.File.mime_type,
      );
      saveAs(blob, this.outputObject.File.name);
    },
    dataURItoBlob(base64String, mime, sliceSize = 512) {
      const byteCharacters = atob(base64String);
      const byteArrays = [];

      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: mime });
      return blob;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../index';
</style>
